var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconNormalHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20817 1.58337C4.94252 1.58337 3.9165 2.60939 3.9165 3.87504C3.9165 5.14069 4.94252 6.16671 6.20817 6.16671C7.47382 6.16671 8.49984 5.14069 8.49984 3.87504C8.49984 2.60939 7.47382 1.58337 6.20817 1.58337ZM2.6665 3.87504C2.6665 1.91903 4.25216 0.333374 6.20817 0.333374C8.16418 0.333374 9.74984 1.91903 9.74984 3.87504C9.74984 5.83105 8.16418 7.41671 6.20817 7.41671C4.25216 7.41671 2.6665 5.83105 2.6665 3.87504ZM6.20817 8.66671C4.93734 8.66671 3.71856 9.17154 2.81995 10.0702C1.92134 10.9688 1.4165 12.1875 1.4165 13.4584C1.4165 13.8036 1.13668 14.0834 0.791504 14.0834C0.446326 14.0834 0.166504 13.8036 0.166504 13.4584C0.166504 11.856 0.803035 10.3193 1.93607 9.18627C3.0691 8.05324 4.60582 7.41671 6.20817 7.41671C7.81052 7.41671 9.34724 8.05324 10.4803 9.18627C11.6133 10.3193 12.2498 11.856 12.2498 13.4584C12.2498 13.8036 11.97 14.0834 11.6248 14.0834C11.2797 14.0834 10.9998 13.8036 10.9998 13.4584C10.9998 12.1875 10.495 10.9688 9.59639 10.0702C8.69778 9.17154 7.479 8.66671 6.20817 8.66671Z",
    fill: "#0C2340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconNormalHuman);
export default __webpack_public_path__ + "static/media/streamline-icon-normal-human.35c17a54.svg";
export { ForwardRef as ReactComponent };